import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { withTranslation } from "gatsby-plugin-react-i18next"
import isEqual from "lodash/isEqual"
import InfiniteScroll from "react-infinite-scroll-component"
import breakpoints from "../../../styles/breakpoints"
import Loader from "../../Core/Loader"
import ProductCard from "./ProductCard"

const DEFAULT_COUNT = 24

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: auto;
  column-gap: 17px;
  row-gap: 21px;
  padding: 0 16px;
  margin-top: 12px;

  @media (min-width: ${breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: auto;
    row-gap: 23px;
    column-gap: 34px;
    padding: 32px;
    margin-top: 0;
  }
  @media (min-width: ${breakpoints.lg}) {
    margin-top: 33px;
    padding: 0;
  }
`

const Portrait = styled.div`
  @media (min-width: ${breakpoints.md}) {
    grid-row: ${(props) => `${props.row} / ${props.row + 2}`};
    grid-column: 1 / 3;
  }
`

const Wide = styled.div`
  @media (min-width: ${breakpoints.md}) {
    grid-column: ${(props) => (props.left ? "1 / 3" : "2/-1")};
  }
`

const ProductList = ({ products, colours, engagementMaterials, t }) => {
  const [hasMore, setHasMore] = useState(products.length >= DEFAULT_COUNT)
  const [items, setItems] = useState(products.slice(0, DEFAULT_COUNT))
  const [page, setPage] = useState(1)

  const productLayout = []

  items.forEach((product, index) => {
    productLayout.push(
      <div key={index}>
        <ProductCard
          product={product}
          colours={colours}
          engagement={product.product_type === "engagement_ring"}
          diamonds={engagementMaterials?.diamonds}
          bands={engagementMaterials?.bands}
        />
      </div>
    )
  })

  const fetchMoreData = () => {
    if (items.length >= products.length) {
      setHasMore(false)
      return
    }

    const nextPage = page + 1
    const nextItems = products.slice(items.length, DEFAULT_COUNT * nextPage)

    setTimeout(() => {
      setItems(items.concat(nextItems))
      setPage(nextPage)
    }, 500)
  }

  const prevProducts = useRef(products)

  useEffect(() => {
    if (!isEqual(products, prevProducts.current)) {
      setItems(products.slice(0, DEFAULT_COUNT))
      setHasMore(products.length >= DEFAULT_COUNT)
      prevProducts.current = products
    }
  }, [products])
  useEffect(() => {
    if (!isEqual(products, prevProducts.current)) {
      setItems(products.slice(0, DEFAULT_COUNT))
      setHasMore(products.length >= DEFAULT_COUNT)
      prevProducts.current = products
    }
  }, [products])

  return (
    <div>
      <InfiniteScroll
        dataLength={items.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<Loader />}
        scrollThreshold={0.6}
      >
        <Grid>{productLayout}</Grid>
      </InfiniteScroll>
    </div>
  )
}

export default withTranslation()(ProductList)
